import * as Yup from "yup";


const valAlphaOnly = /^[a-zA-Z .,]+$/;
const valNamaLengkap = /^[a-zA-Z .',]+$/;
const valAlphaNumeric = /^[a-zA-Z 1234567890]+$/;
const valAlphaNumericSpecial = /^[a-zA-Z 1234567890.,'-]+$/;
const nonFirstZero = /^[1-9].*/;
const numericOnly = /^[0-9]*$/;
const dobMax = '2010-01-01';

function equalTo(ref, msg) {
    return this.test({
        name: 'equalTo',
        exclusive: false,
        message: msg || '${path} must be the same as ${reference}',
        params: {
            reference: ref.path
        },
        test: function (value) {
            return value === this.resolve(ref)
        }
    })
};

Yup.addMethod(Yup.string, 'equalTo', equalTo);

export const SchemaPage4Job = Yup.object().shape({
    OccupationId: Yup.string().required('Pekerjaan harus dipilih'),
    OccupationOthers: Yup.string()
        .when('OccupationId', {
            is: (OccupationId) => OccupationId === "12",
            then: Yup.string().trim().required('Harus diisi').max(30, 'Maksmimal 30 karakter')
        }),
    PositionId: Yup.string().required('Posisi harus dipilih'),
    PositionOthers: Yup.string()
        .when('PositionId', {
            is: (PositionId) => PositionId === "41",
            then: Yup.string().trim().required('Harus diisi').min(2, 'Minimal 2 karakter').max(30, 'Maksimal 30 karakter')
                .matches(/^[a-z &A-Z]+$/, "Only alpha character")
        }),
    BusinessFieldOthers: Yup.string()
        .when('BusinessFieldId', {
            is: (BusinessFieldId) => BusinessFieldId === "25",
            then: Yup.string().trim().required('Harus diisi').max(40, "Maksimal 40 karakter").min(2, "Minimal 2 karakter")
                .matches(/^[a-z &A-Z]+$/, "Only alpha character")
        }),
    BusinessFieldId: Yup.string().required('Bidang Usaha harus dipilih'),
    IncomePerAnnumId: Yup.string().required('Penghasilan Per Tahun harus dipilh'),
    FundSourceId: Yup.string().required('Sumber Penghasilan harus diisi'),
    FundSourceOthers: Yup.string()
        .when('FundSourceId', {
            is: (FundSourceId) => FundSourceId === "1",
            then: Yup.string().trim().required('Harus diisi').max(15, 'Maksimal 15 karakter')
        }),
    CompanyName: Yup.string().trim().required('Nama Tempat Bekerja harus diisi').matches(/^[a-z &A-Z]+$/, "Only alpha character").min(2, 'Minimal 2 karakter'),
    CompanyAddress: Yup.string().trim().required('Alamat harus diisi').matches(/^[A-Za-z .-].*/, 'Karakter pertama harus bentuk huruf').max(40, 'Maksimal 40 karakter'),
    CompanyAddressCity: Yup.string().trim().required('Harus diisi').min(3, 'Minimal 3 karakter').max(40, 'Maksimal 4 karakter'),
    CompanyPhoneAreaCode: Yup.number().required('Kode Area harus diisi').max(9999, 'Kode Are maks 4 digit'),
    CompanyPhoneNumber: Yup.string().max(10, "Maksimal 10 karakter").required('No. Telp harus diisi'),
    CompanyPostalCode: Yup.number().required('Harus diisi').min(10000).max(99999),
    LengthOfWork: Yup.string().required('Harus diisi').max(99, 'Maksimal 99 ').min(1).matches(/^[0-9]+$/, "Hanya boleh diisi angka"),
    InvestmentObjectiveId: Yup.string().required('Tujuan Investasi harus diisi'),
    EmergencyContactName: Yup.string().required('Nama Kontak Darurat harus diisi'),
    EmergencyContactPhoneNumber: Yup.string().required('No Telepon harus diisi').matches(/^[0-9]+$/),
    EmergencyContactRelation: Yup.string().required('Hubungan harus diisi'),
    //EducationId: Yup.string()
    //    .when('RiskLevel', {
    //        is: (RiskLevel) => RiskLevel === "High",
    //        then: Yup.string().required('Pendidikan Terakhir harus diisi')
    //    }),
    PhotoDokumenHubunganBeneficialOwner: Yup.string().when('OccupationId', {
        is: (pekerjaanid) => ["3", "7"].includes(pekerjaanid),
        then: Yup.string().trim().required('Harus diisi')
    }),

    BeneficialOwner: Yup.object().when('OccupationId', {
        is: (pekerjaanid) => ["3", "7"].includes(pekerjaanid),
        then: Yup.object().shape({
            Name: Yup.string()
                .required('Nama beneficial owner wajib diisi')
                .min(2, 'Nama minimal 2 karakter')
                .max(100, 'Nama maksimal 100 karakter'),

            // Identity Information
            IdentityType: Yup.string()
                .required('Tipe identitas wajib dipilih'),

            IdentityNumber: Yup.string()
                .required('Nomor identitas wajib diisi')
                .matches(/^[0-9]+$/, 'Nomor Identitas harus berupa angka')
                .min(10, 'Nomor identitas minimal 10 karakter')
                .max(20, 'Nomor identitas maksimal 20 karakter'),

            // Identity Address
            IdentityAddressLine: Yup.string()
                .required('Alamat identitas wajib diisi')
                .min(10, 'Alamat minimal 10 karakter')
                .max(200, 'Alamat maksimal 200 karakter'),

            IdentityRT: Yup.string()
                .required('RT wajib diisi')
                .matches(/^[0-9]{1,3}$/, 'RT harus berupa angka 1-3 digit'),

            IdentityRW: Yup.string()
                .required('RW wajib diisi')
                .matches(/^[0-9]{1,3}$/, 'RW harus berupa angka 1-3 digit'),

            IdentityVillage: Yup.string()
                .required('Kelurahan wajib diisi')
                .min(2, 'Kelurahan minimal 2 karakter')
                .max(50, 'Kelurahan maksimal 50 karakter'),

            IdentitySubDistrict: Yup.string()
                .required('Kecamatan wajib diisi')
                .min(2, 'Kecamatan minimal 2 karakter')
                .max(50, 'Kecamatan maksimal 50 karakter'),

            IdentityCityId: Yup.number()
                .required('Kota identitas wajib dipilih')
                .positive('Kota identitas harus dipilih'),

            IdentityProvinceId: Yup.number()
                .required('Provinsi identitas wajib dipilih')
                .positive('Provinsi identitas harus dipilih'),

            IdentityPostalCode: Yup.number()
                .required('Kode pos identitas wajib diisi')
                .min(10000, 'Kode pos harus 5 digit')
                .max(99999, 'Kode pos harus 5 digit'),

            // Residential Address (conditional based on IdentityAddressResidential)
            IdentityAddressResidential: Yup.boolean(),

            ResidentialAddressLine: Yup.string().when('IdentityAddressResidential', {
                is: false,
                then: Yup.string()
                    .required('Alamat domisili wajib diisi')
                    .min(10, 'Alamat domisili minimal 10 karakter')
                    .max(200, 'Alamat domisili maksimal 200 karakter'),
                otherwise: Yup.string().nullable()
            }),

            ResidentialRT: Yup.string().when('IdentityAddressResidential', {
                is: false,
                then: Yup.string()
                    .required('RT domisili wajib diisi')
                    .matches(/^[0-9]{1,3}$/, 'RT harus berupa angka 1-3 digit'),
                otherwise: Yup.string().nullable()
            }),

            ResidentialRW: Yup.string().when('IdentityAddressResidential', {
                is: false,
                then: Yup.string()
                    .required('RW domisili wajib diisi')
                    .matches(/^[0-9]{1,3}$/, 'RW harus berupa angka 1-3 digit'),
                otherwise: Yup.string().nullable()
            }),

            ResidentialVillage: Yup.string().when('IdentityAddressResidential', {
                is: false,
                then: Yup.string()
                    .required('Kelurahan domisili wajib diisi')
                    .min(2, 'Kelurahan domisili minimal 2 karakter')
                    .max(50, 'Kelurahan domisili maksimal 50 karakter'),
                otherwise: Yup.string().nullable()
            }),

            ResidentialSubDistrict: Yup.string().when('IdentityAddressResidential', {
                is: false,
                then: Yup.string()
                    .required('Kecamatan domisili wajib diisi')
                    .min(2, 'Kecamatan domisili minimal 2 karakter')
                    .max(50, 'Kecamatan domisili maksimal 50 karakter'),
                otherwise: Yup.string().nullable()
            }),

            ResidentialCityId: Yup.number().when('IdentityAddressResidential', {
                is: false,
                then: Yup.number()
                    .required('Kota domisili wajib dipilih')
                    .positive('Kota domisili harus dipilih'),
                otherwise: Yup.number().nullable()
            }),

            ResidentialProvinceId: Yup.number().when('IdentityAddressResidential', {
                is: false,
                then: Yup.number()
                    .required('Provinsi domisili wajib dipilih')
                    .positive('Provinsi domisili harus dipilih'),
                otherwise: Yup.number().nullable()
            }),

            ResidentialPostalCode: Yup.number().when('IdentityAddressResidential', {
                is: false,
                then: Yup.number()
                    .required('Kode pos domisili wajib diisi')
                    .min(10000, 'Kode pos harus 5 digit')
                    .max(99999, 'Kode pos harus 5 digit'),
                otherwise: Yup.number().nullable()
            }),


            // Personal Information
            Citizenship: Yup.string()
                .required('Kewarganegaraan wajib diisi')
                .oneOf(['WNI', 'WNA'], 'Kewarganegaraan harus WNI atau WNA'),

            CitizenshipCountry: Yup.string().when('Citizenship', {
                is: 'WNA',
                then: Yup.string()
                    .required('Negara asal wajib diisi untuk WNA')
                    .min(2, 'Negara asal minimal 2 karakter')
                    .max(50, 'Negara asal maksimal 50 karakter'),
                otherwise: Yup.string().nullable()
            }),

            BirthDate: Yup.date()
                .required('Tanggal lahir wajib diisi')
                .max(new Date(), 'Tanggal lahir tidak boleh lebih dari hari ini'),

            BirthPlace: Yup.string()
                .required('Tempat lahir wajib diisi'),

            GenderId: Yup.number()
                .required('Jenis kelamin wajib dipilih')
                .positive('Jenis kelamin harus dipilih'),

            MaritalStatusId: Yup.number()
                .required('Status pernikahan wajib dipilih')
                .positive('Status pernikahan harus dipilih'),

            // Financial Information
            IncomeSourceId: Yup.number()
                .required('Sumber penghasilan wajib dipilih')
                .positive('Sumber penghasilan harus dipilih'),

            IncomePerAnnumBCAId: Yup.number()
                .required('Penghasilan per tahun wajib dipilih')
                .positive('Penghasilan per tahun harus dipilih'),

            // Occupation Information
            OccupationId: Yup.string()
                .required('Pekerjaan wajib dipilih'),

            OccupationOthers: Yup.string().when('OccupationId', {
                is: (occupationId) => occupationId === '12', //
                then: Yup.string()
                    .required('Pekerjaan lainnya wajib diisi')
                    .min(2, 'Pekerjaan lainnya minimal 2 karakter')
                    .max(50, 'Pekerjaan lainnya maksimal 50 karakter')
                    .test('invalid-occupation', 'Pekerjaan tidak boleh "Ibu Rumah Tangga" atau "Pelajar"', function (value) {
                        if (!value) return true;
                        const lowerValue = value.toLowerCase().trim();
                        return lowerValue !== 'ibu rumah tangga' && lowerValue !== 'pelajar';
                    }),
                otherwise: Yup.string().nullable()
            }),

            BusinessField: Yup.string()
                .required('Bidang usaha wajib diisi')
                .min(2, 'Bidang usaha minimal 2 karakter')
                .max(100, 'Bidang usaha maksimal 100 karakter')
                .test('invalid-business-field', 'Bidang usaha tidak boleh "Ibu Rumah Tangga" atau "Pelajar"', function (value) {
                    if (!value) return true;
                    const lowerValue = value.toLowerCase().trim();
                    return lowerValue !== 'ibu rumah tangga' && lowerValue !== 'pelajar';
                }),

            BusinessFieldId: Yup.string().required('Bidang usaha wajib diisi'),

            Position: Yup.string()
                .required('Posisi wajib diisi')
                .min(2, 'Posisi minimal 2 karakter')
                .max(50, 'Posisi maksimal 50 karakter')
                .test('invalid-position', 'Posisi tidak boleh "Ibu Rumah Tangga" atau "Pelajar"', function (value) {
                    if (!value) return true;
                    const lowerValue = value.toLowerCase().trim();
                    return lowerValue !== 'ibu rumah tangga' && lowerValue !== 'pelajar';
                }),

            PositionId: Yup.string().required('Posisi wajib diisi'),

            CompanyName: Yup.string()
                .required('Nama perusahaan wajib diisi')
                .min(2, 'Nama perusahaan minimal 2 karakter')
                .max(100, 'Nama perusahaan maksimal 100 karakter'),

            Relationship: Yup.string()
                .required('Hubungan wajib diisi')
                .min(2, 'Hubungan minimal 2 karakter')
                .max(50, 'Hubungan maksimal 50 karakter'),
        }),
    }),
    otherwise: Yup.object().shape({
        Name: Yup.string().nullable(),
        IdentityType: Yup.string().nullable(),
        IdentityNumber: Yup.string().nullable(),
        IdentityAddressLine: Yup.string().nullable(),
        IdentityRT: Yup.string().nullable(),
        IdentityRW: Yup.string().nullable(),
        IdentityVillage: Yup.string().nullable(),
        IdentitySubDistrict: Yup.string().nullable(),
        IdentityCityId: Yup.number().nullable(),
        IdentityProvinceId: Yup.number().nullable(),
        IdentityPostalCode: Yup.number().nullable(),
        IdentityAddressResidential: Yup.boolean().nullable(),
        ResidentialAddressLine: Yup.string().nullable(),
        ResidentialRT: Yup.string().nullable(),
        ResidentialRW: Yup.string().nullable(),
        ResidentialVillage: Yup.string().nullable(),
        ResidentialSubDistrict: Yup.string().nullable(),
        ResidentialCityId: Yup.number().nullable(),
        ResidentialProvinceId: Yup.number().nullable(),
        ResidentialPostalCode: Yup.number().nullable(),
        Citizenship: Yup.string().nullable(),
        CitizenshipCountry: Yup.string().nullable(),
        BirthDate: Yup.date().nullable(),
        GenderId: Yup.number().nullable(),
        IncomeSourceId: Yup.number().nullable(),
        MaritalStatusId: Yup.number().nullable(),
        IncomePerAnnumBCAId: Yup.number().nullable(),
        OccupationId: Yup.number().nullable(),
        OccupationOthers: Yup.string().nullable(),
        BusinessField: Yup.string().nullable(),
        Position: Yup.string().nullable(),
        CompanyName: Yup.string().nullable(),
        Relationship: Yup.string().nullable(),

    }),

    //BeneficialOwner: Yup.object().shape({
    //    Name: Yup.string()
    //        .required('Nama beneficial owner wajib diisi')
    //        .min(2, 'Nama minimal 2 karakter'),
    //    IdentityType: Yup.string().required('Kartu Identitas harus dipilih'),
    //}),
    LongStayAtLastAddressYear: Yup.string().required('Lama Tinggal harus diisi'),
    HaveAccountsInOtherBank: Yup.string().required(),
    OtherBankOrInstitutionName: Yup.string()
        .when(['RiskLevel', 'HaveAccountsInOtherBank'], {
            is: (RiskLevel, HaveAccountsInOtherBank) => RiskLevel === "High" && HaveAccountsInOtherBank === "1",
            then: Yup.string().required('Harus diisi')
        }),
    LongOwnershipInOtherBankOrInstitutionYear: Yup.string()
        .when(['RiskLevel', 'HaveAccountsInOtherBank'], {
            is: (RiskLevel, HaveAccountsInOtherBank) => RiskLevel === "High" && HaveAccountsInOtherBank === "1",
            then: Yup.string().required('Harus diisi')
        }),
});


export const SchemaPage1Email = Yup.object().shape({
    Email: Yup.string().required('Email harus diisi').email('Masukan format yang benar (john@example.com)'),
    EmailConfirmation: Yup.string().required('Harus diisi').email('Email tidak valid').equalTo(Yup.ref('Email')),
    Agreement: Yup.boolean().oneOf([true], 'Anda harus menyetujui syarat dan ketentuan')
});


// mulai dari sini 
export const SchemaPageDokumenPendukung = Yup.object().shape({
    PhotoKTP: Yup.string().required('Harus diisi'),
    PhotoSelfieKTP: Yup.string().required('Harus diisi'),
    SignatureImage: Yup.string().required('Harus diisi'),
});


export const SchemaPage1PersonalData = Yup.object().shape({
    Address1: Yup.string().required('Alamat harus diisi').trim().min(5, 'Minimal 5 karakter').max(100, 'Maksimal 100 karakter'),
    RT: Yup.string().required('RT harus diisi').matches(/^[0-9]+$/, "Harus hanya angka").max(3, 'RT harus diisi 3 digit'),
    RW: Yup.string().required('RW harus diisi').matches(/^[0-9]+$/, "Harus hanya angka").max(3, 'RW harus diisi 3 digit'),
    ProvinceId: Yup.string().required('Provinsi harus dipilih'),
    CityId: Yup.string().required('Kota harus dipilih'),
    SubDistrict: Yup.string().required('Kecamatan harus diisi'),
    Village: Yup.string().required('Kelurahan harus diisi'),
    PostalCode: Yup.number().required('Harus diisi').min(10000, 'Minimal 10000').max(99999, 'Maksimal 99999'),
    Religion: Yup.string().required('Agama harus dipilih'),
    MothersMaidenName: Yup.string().required('Nama Ibu Kandung harus diisi').matches(/^[a-z A-Z]+$/, "Hanya boleh karakter Alfabet").max(20, 'Maksimal 20 karakter'),
    MaritalStatusId: Yup.string().required('Status Pernikahan harus dipilih'),
    SpouseName: Yup.string()
        .when('MaritalStatusId', {
            is: (MaritalStatusId) => MaritalStatusId == 2,
            then: Yup.string().required('Harus diisi').min(3, 'Minimal 3 karakter')
        }),
    NPWP: Yup.string().required('NPWP harus dipilih'),
    //NPWPNumber: Yup.string()
    //    .when('NPWP', {
    //        is: (NPWP) => NPWP !== "1",
    //        then: Yup.string().required('Harus diisi').matches(/^[0-9]+$/, "Harus hanya angka").min(15, 'Minimal 15 karakter').max(15, 'Maksimal 15 karakter')
    //    }),
    //PhotoNPWP: Yup.string()
    //    .when('NPWP', {
    //        is: (NPWP) => NPWP !== "1",
    //        then: Yup.string().required('Harus dipilih')
    //    }),
    MobilePhone: Yup.string().required('No Handphone harus diisi').matches(/^[0-9]+$/, "Harus hanya angka").min(10, 'No Handphone min 10 digit').max(14, 'No Handphone maks 14 digit'),
    MobilePhoneConfirmation: Yup.string().required('No Handphone harus diisi').matches(/^[0-9]+$/, "Harus hanya angka").min(10, 'No Handphone min 10 digit').max(14, 'No Handphone maks 14 digit')
        .equalTo(Yup.ref('MobilePhone')),
    HomePhone: Yup.string().trim().matches(/^[0-9]+$/, "Harus hanya angka").max(10, "Maksimal 10 karakter"),
    HomePhoneAreaCode: Yup.string().matches(/^[0-9]+$/, "Harus hanya angka").min(3, 'No Handphone maks 3 digit').max(4, 'No Handphone maks 4 digit'),
    EducationId: Yup.string().required('Harus dipilih'),
    //NotHavingNPWPReason: Yup.string()
    //    .when('NPWP', {
    //        is: (NPWP) => NPWP === "1",
    //        then: Yup.string().required('Harus dipilih')
    //    }),
    //NPWPAddress1: Yup.string()
    //    .when(['NPWPAddressIdemWithKTP', 'NPWP'], {
    //        is: (NPWPAddressIdemWithKTP, NPWP) => NPWPAddressIdemWithKTP === 'false' && NPWP === '2',
    //        then: Yup.string().trim().required('Harus diisi').min(5, 'Minimal 5 karakter').max(100, 'Maksimal 100 karakter')
    //    }),
    //NPWPAddressRT: Yup.string()
    //    .when(['NPWPAddressIdemWithKTP', 'NPWP'], {
    //        is: (NPWPAddressIdemWithKTP, NPWP) => NPWPAddressIdemWithKTP === 'false' && NPWP === '2',
    //        then: Yup.string().required('Harus diisi')
    //    }),
    //NPWPAddressRW: Yup.string()
    //    .when(['NPWPAddressIdemWithKTP', 'NPWP'], {
    //        is: (NPWPAddressIdemWithKTP, NPWP) => NPWPAddressIdemWithKTP === 'false' && NPWP === '2',
    //        then: Yup.string().required('Harus diisi')
    //    }),
    //NPWPAddressVillage: Yup.string()
    //    .when(['NPWPAddressIdemWithKTP', 'NPWP'], {
    //        is: (NPWPAddressIdemWithKTP, NPWP) => NPWPAddressIdemWithKTP === 'false' && NPWP === '2',
    //        then: Yup.string().trim().required('Harus dipilih')
    //    }),
});



export const SchemaPageAggreementBank = Yup.object().shape({
    AgreePernyataanNasabah: Yup.string()
        .when('BankCode2', {
            is: (PilihBank) => PilihBank == "BCA",
            then: Yup.string().required('Anda harus menyetujui pernyataan nasabah, silakan gulir pernyataan diatas')
        }),
});

export const SchemaPageAggreemenPernyataan = Yup.object().shape({
    AgreementPernyataan1: Yup.string().required('Anda harus menyetujui pernyataan nasabah, silakan gulir pernyataan diatas'),
});

export const SchemaPageDukcapilValidation = Yup.object().shape({
    nik: Yup.string().required('NIK harus diisi').matches(numericOnly, 'Hanya dapat diisi dengan angka').matches(nonFirstZero, 'Angka pertama tidak boleh 0').min(16, 'NIK harus 16 karakter').max(16, 'NIK harus 16 karakter'), //.min(1000000000000000, 'NIK harus 16 digit').max(9999999999999999, 'NIK harus 16 digit'),
    fullname: Yup.string().required('Nama Lengkap harus diisi').matches(valNamaLengkap, 'Nama Lengkap hanya boleh huruf').min(3, 'Nama Lengkap minimal 3 huruf'),
    pob: Yup.string().required('Tempat Lahir harus diisi').matches(valAlphaNumericSpecial, 'Tempat Lahir hanya boleh angka dan huruf').min(3, 'Tempat Lahir minimal 3 huruf'),
    dob: Yup.date().required('Tgl Lahir harus diisi').max(new Date(dobMax), 'Pilih tanggal yang lebih kecil'),
    //code: Yup.string().required('Harus diisi').min(4, 'Minimal 4 huruf').matches(valAlphaNumeric, 'Hanya angka dan huruf'),
    gender: Yup.string().required('Jenis Kelamin harus dipilih')
});



// WEBPACK FOOTER //
// ./src/components/validation/Schema.js